module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-69.67471cee.gif";